<div class="row" >
  <div class="col-6">
    <div class="form-inline">
      <span class="text-bidit-primary">
        {{quoteJobTypeDesc}}
      </span>
    </div>
    <div class="form-inline">
      <label for="quote_BidAmount" class="text-bidit-primary">Quote Amount:</label>
      <span id="quote_BidAmount" class="text-bidit-primary">{{quote.quote_BidAmount | currency}}</span>
    </div>
    <div class="form-inline text-bidit-primary">
      Project Type:
      <span *ngIf="quote.quote_Converted; else quoteBlock">Job</span>
      <ng-template #quoteBlock>
        <span *ngIf="quote.quote_IsLead">Lead</span>
        <span *ngIf="!quote.quote_IsLead">Quote</span>
      </ng-template>
    </div>
    <div class="form-inline text-bidit-primary">
      <span class="text-bidit-primary">Status:</span>
      <div *ngIf="quote.quote_IsLost">Lost</div>
      <div *ngIf="quote.isExpired">Expired</div>
      <div *ngIf="quote.quote_IsLost == false && quote.isExpired == false">Active</div>
    </div>
  </div>
  <div class="col-6">
    <div class="form-inline">
      <label for="quoteAssignedTo" class="text-bidit-primary">Salesperson:</label>
      <span id="quoteAssignedTo" class="text-bidit-primary">{{quote.assignedTo?.firstName}} {{quote.assignedTo?.lastName}} </span>
    </div>
    <div class="form-inline">
      <label for="quoteOffice" class="text-bidit-primary">Office:</label>
      <span id="quoteOffice" class="text-bidit-primary">{{quote.office?.office_Name}}</span>
    </div>
    <div class="form-inline">
      <label for="customer_CreatedBy" class="text-bidit-primary">Created By:</label>
      <span id="customer_CreatedBy" class="text-bidit-primary">{{quote.createdBy?.firstName}} {{quote.createdBy?.lastName}} </span>
    </div>
    <div class="form-inline">
      <label for="customer_Created" class="text-bidit-primary">Date:</label>
      <span id="customer_Created" class="text-bidit-primary">{{quote.quote_Created  | date: 'M/d/yyyy'}}</span>
    </div>
  </div>
</div>
